/*

Ajax Load More callbacks

https://connekthq.com/plugins/ajax-load-more/docs/callback-functions

*/

(function ($) {
    function advisorModal() {
        $('.m-listing-advisor a').each(function () {
            $(this).bind('click', function (e) {
                var href = $(this).attr('href'),
                    html = $('html, body');

                scrollto = $(href).offset().top;
                html.animate({ scrollTop: scrollto });

                $('#modal-advisor h2').text(
                    $(this).closest('.m-listing-advisor').attr('data-name')
                );

                let advisorEmail = $(this)
                    .closest('.m-listing-advisor')
                    .attr('data-email');

                if (advisorEmail) {
                    $('#modal-advisor-email').attr(
                        'href',
                        'mailto:' +
                            $(this)
                                .closest('.m-listing-advisor')
                                .attr('data-email')
                    );

                    $('#modal-advisor-email').text(
                        'Email ' +
                            $(this)
                                .closest('.m-listing-advisor')
                                .attr('data-name')
                    );
                    $('.m-modal-advisor__cols').addClass(
                        'm-modal-advisor__cols--pad'
                    );
                    $('.m-modal-advisor__email').addClass(
                        'm-modal-advisor__email--isactive'
                    );
                } else {
                    $('.m-modal-advisor__cols').removeClass(
                        'm-modal-advisor__cols--pad'
                    );
                    $('#modal-advisor-email').attr('href', '');
                    $('#modal-advisor-email').text('');
                    $('.m-modal-advisor__email').removeClass(
                        'm-modal-advisor__email--isactive'
                    );
                }

                let advisorOrganisation = $(this)
                    .closest('.m-listing-advisor')
                    .attr('data-organisation');

                if (advisorOrganisation) {
                    $('#modal-advisor-organisation').text(
                        $(this)
                            .closest('.m-listing-advisor')
                            .attr('data-organisation')
                    );
                    $('.m-modal-advisor__organisation').addClass(
                        'm-modal-advisor__organisation--isactive'
                    );
                } else {
                    $('#modal-advisor-organisation').text('');
                    $('.m-modal-advisor__organisation').removeClass(
                        'm-modal-advisor__organisation--isactive'
                    );
                }

                $('#modal-advisor-info').html(
                    $(this).closest('.m-listing-advisor').attr('data-bio')
                );

                $('#modal-advisor-terms').html(
                    $(this).closest('.m-listing-advisor').attr('data-terms')
                );

                $('#modal-advisor').addClass('m-modal--isactive');
                $('#modal-advisor-close').addClass(
                    'm-modal__close-bg--isactive'
                );
                $('.m-modal-toggle').focus();

                e.preventDefault();
                e.stopPropagation();
            });
        });
    }

    // Initial load using ALM Preload
    advisorModal();

    // almComplete() is dispatched after every successful Ajax Load More query

    window.almComplete = function (alm) {
        advisorModal();
    };

    // almDone() is dispatched after all posts have been loaded and there are zero posts remaining

    window.almDone = function (alm) {
        var el = alm.listing;
        var message = $(el).closest('.m-listing').find('.m-listing__message');

        if (!$(message).hasClass('m-listing__message--isactive')) {
            // Only show message if another hasn't already been shown e.g. by almEmpty()
            $(message).find('p').text($(message).attr('data-done'));
            $(message).addClass('m-listing__message--isactive');
        }
    };

    // almEmpty() is dispatched when zero results are returned in the initial Ajax Load More query

    window.almEmpty = function (alm) {
        var el = alm.listing;
        var message = $(el).closest('.m-listing').find('.m-listing__message');

        $(message).find('p').text($(message).attr('data-empty'));
        $(message).addClass('m-listing__message--isactive');
    };
})(jQuery);
